import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { ProductCountCard } from "./ProductCountCard";
import { FC } from "react";
import { VendorCountCard } from "./VendorCountCard";
import { CompanyCountCard } from "./CompanyCountCard";
import { InstallCountCard } from "./InstallCountCard";
import { ProductsTable } from "../ProductsTable/ProductsTable";
import { useGetProductsByCategoryIds } from "./hooks/useGetProductsByCategoryIds";

interface CategoryContentProps {
  categoryName: string;
  leafCategoryIds: string[];
}

export const CategoryContent: FC<CategoryContentProps> = (props) => {
  const { products, loading } = useGetProductsByCategoryIds(
    props.leafCategoryIds
  );

  return (
    <Stack gap={3} p={2}>
      <OutlinedPaper id="category-name" sx={{ p: 3 }}>
        <Typography variant="h3" data-testid="catalog-category-name">
          {props.categoryName}
        </Typography>
      </OutlinedPaper>

      <Box display="flex" justifyContent="space-between" gap={2}>
        <ProductCountCard leafCategoryIds={props.leafCategoryIds} />
        <VendorCountCard leafCategoryIds={props.leafCategoryIds} />
      </Box>
      <Box display="flex" justifyContent="space-between" gap={2}>
        <CompanyCountCard leafCategoryIds={props.leafCategoryIds || []} />
        <InstallCountCard leafCategoryIds={props.leafCategoryIds || []} />
      </Box>

      <OutlinedPaper id="products-table" sx={{ p: 3 }}>
        <ProductsTable
          text={`Products in the ${props.categoryName} Category`}
          products={products}
          isLoading={loading}
        />
      </OutlinedPaper>
    </Stack>
  );
};
